import ListingTable from '../ListingTable/ListingTable';
import { ReactNode, useEffect, useState } from 'react';
import moment from 'moment';
import OpportunityActions from './opportunityTableCell/OpportunityActions';
import OpportunityCompany from './opportunityTableCell/OpportunityCompany';
import { ApplicationRoundDocument, ApplicationRoundStatus, ApplicationStatus, UIOfflineDriveRoundDetail } from 'types';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import MobileCardForOpportunityTable from './MobileCardForOpportunityTable';

interface Props {
	candidateRounds: UIOfflineDriveRoundDetail[];
	isPlaced?: boolean;
	driveId: string;
}

export default function OpportunityTable({ driveId, candidateRounds, isPlaced }: Props) {
	const { positionId } = useParams();
	const isMobile = useMediaQuery('(max-width: 1280px)');
	const tableHeaders: { id: string; label: string; align?: 'center' | 'left' | 'right' | 'inherit' | 'justify' }[] = [
		{ id: 'company', label: 'Company' },
		{ id: 'application_status', label: 'Application Status', align: 'left' },
		{ id: 'round_status', label: 'Round Status' },
		{ id: 'salary_offering', label: 'Salary Offering' },
		{ id: 'bd_poc', label: 'BD POC' },
		{ id: 'round_type', label: 'Round Type' },
		{ id: 'created_at', label: 'Created At' },
		{ id: 'actions', label: 'Actions' },
	];

	const [tableRows, setTableRows] = useState<{ id: string; tableDataJsx: React.ReactNode }[][]>([]);
	useEffect(() => {
		const allTableRows: {
			id: string;
			tableDataJsx: ReactNode;
		}[][] =
			candidateRounds?.map((applicationRound, index) => [
				{
					id: 'company',
					tableDataJsx: (
						<OpportunityCompany
							companyName={applicationRound?.company?.name}
							role={applicationRound?.position?.title}
							logoUrl={applicationRound?.company?.logo}
							companyUrl={applicationRound?.company?.url || ''}
							offlineDriveRoom={applicationRound?.company?.offlineDriveRoom}
							positionLabel={applicationRound?.position?.positionLabel || ''}
						/>
					),
				},
				{
					id: 'application_status',
					tableDataJsx: <p>{applicationRound?.application?.status}</p>,
				},
				{
					id: 'round_status',
					tableDataJsx: <div className="flex items-center justify-center">{applicationRound?.roundStatus}</div>,
				},
				{
					id: 'salary_offering',
					tableDataJsx: (
						<div className="flex items-center justify-center">
							<p className="text-base font-[#28293D] font-medium">{`${applicationRound?.position?.salary?.min} - ${applicationRound?.position?.salary?.max} LPA`}</p>
						</div>
					),
				},
				{
					id: 'bd_poc',
					tableDataJsx: (
						<div className="flex items-center justify-center">
							<p className="text-base font-[#28293D] font-medium">{`${applicationRound?.company?.bdPoc?.name}`}</p>
						</div>
					),
				},
				{
					id: 'round_type',
					tableDataJsx: <div className="flex items-center justify-center">{applicationRound.customLabel}</div>,
				},
				{
					id: 'created_at',
					tableDataJsx: (
						<div className="flex items-center justify-center">
							{moment(applicationRound.roundCreatedAt).format('D MMM, hh:mma')}
						</div>
					),
				},
				{
					id: 'actions',
					tableDataJsx: (
						<div className="flex items-center justify-center">
							{applicationRound.roundStatus !== ApplicationRoundStatus.Rejected ? (
								<OpportunityActions driveId={driveId} applicationRound={applicationRound} isUserPlaced={isPlaced} />
							) : (
								<div className="flex items-center justify-center">
									<p className="text-base font-[#28293D] font-medium">{`-`}</p>
								</div>
							)}
						</div>
					),
				},
			]) || [];
		setTableRows(allTableRows);
	}, [candidateRounds]);

	return (
		<div className="flex max-w-[1440px] mx-auto">
			{!isMobile ? (
				<div className="w-full">
					<ListingTable tableHeaders={tableHeaders} tableRows={tableRows} showPagination={false} />
				</div>
			) : (
				<div className="flex flex-col gap-2 w-full">
					{candidateRounds
						?.filter(round => (positionId ? round?.position?._id?.toString() === positionId?.toString() : true))
						?.map((round: UIOfflineDriveRoundDetail) => {
							return (
								<div>
									<MobileCardForOpportunityTable applicationRound={round} driveId={driveId} />
								</div>
							);
						})}
				</div>
			)}
		</div>
	);
}
